import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { CHART_YEAR_OPTIONS } from '../../chartUtils';

type ChartYearFilterProps = {
  value: string;
  onChange: (value: string) => void;
  labelId?: string;
  includeAllYears?: boolean;
};

export function ChartYearFilter({
  value,
  onChange,
  labelId = 'chart-year-filter',
  includeAllYears = false,
}: ChartYearFilterProps) {
  const options = includeAllYears
    ? CHART_YEAR_OPTIONS
    : CHART_YEAR_OPTIONS.filter((opt) => opt.value !== 'all');

  return (
    <FormControl size="small" sx={{ minWidth: 140 }}>
      <InputLabel id={labelId}>Year</InputLabel>
      <Select
        labelId={labelId}
        label="Year"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
